import * as React from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { clsx } from 'clsx';

import * as styles from './styles.css';
import './../SwiperCarousel/swiper.css';

export interface ICustomSwiperNavigationRef {
  prev: React.RefObject<HTMLButtonElement> | null;
  next: React.RefObject<HTMLButtonElement> | null;
}

interface ISwiperCarouselProps extends Swiper {
  children: React.ReactElement[];
  className?: string;
  navRef: ICustomSwiperNavigationRef;
}

SwiperCore.use([Navigation]);

export function CustomSwiper({ className, children, navRef, ...swiperOptions }: ISwiperCarouselProps) {
  return (
    <div className={clsx('custom_swiper', styles['swiper_wrapper'], `${className}_wrapper`)}>
      <Swiper
        className={className}
        onInit={(swiper: SwiperCore) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-param-reassign
          swiper.params.navigation.prevEl = navRef.prev.current;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-param-reassign
          swiper.params.navigation.nextEl = navRef.next.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        {...swiperOptions}
      >
        {React.Children.map(children, child => (
          <SwiperSlide className={styles['slide']}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
